export type CashRefundStatus = "processing" | "sent" | "failed" | "canceled";

export interface CashRefundRow {
  id: number;
  guid: string;
  event_id: number;
  uid: string;
  status: CashRefundStatus;
  amount: number;
  gross_amount: number;
  fee_amount: number;
  balance_before: number;
  hold_applied: boolean;
  balance_restored: boolean;
  needs_manual_fix: boolean;
  failure_reason: string | null;
  recipient_name: string | null;
  recipient_email: string | null;
  recipient_phone: string | null;
  delivery_method: "EMAIL" | "PHONE";
  phone_verified: boolean;
  /** 'ach' for every new refund; older rows name the payout service they used. */
  provider: string;
  bank_account_last4: string | null;
  bank_account_type: string | null;
  ach_batch_id: number | null;
  /**
   * PENDING once the payment file has gone to the bank. Nothing here can say
   * the money landed: a returned transfer shows up on Ronin's bank statement,
   * not through any API.
   */
  delivery_status: "SCHEDULED" | "PENDING" | "SUCCEEDED" | "FAILED" | null;
  delivery_checked_at: string | null;
  request_ip: string | null;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
  event?: { id: number; name: string } | null;
}

/** Money is off the wristband but no payout has gone out yet. */
export const IN_FLIGHT: CashRefundStatus[] = ["processing"];
